// src/pages/admin/workspace/workspaceCategories.js
//
// PRESENTATION ONLY. Labels already-authorized workspace items with a UI
// category so they can be grouped and filtered. It never decides who can see or
// open anything: items only reach this file after the existing access pipeline
// (resolveDashboardAccess + getWorkspaceItems) has produced them.
export const CATEGORY = {
  ALL: "all",
  DASHBOARDS: "dashboards",
  PORTALS: "portals",
  PAGES: "pages",
  ADMIN: "admin",
  FAVOURITES: "favourites",
};

export const CATEGORY_LABELS = {
  [CATEGORY.ALL]: "All",
  [CATEGORY.DASHBOARDS]: "Dashboards",
  [CATEGORY.PORTALS]: "Campus Portals",
  [CATEGORY.PAGES]: "Pages",
  [CATEGORY.ADMIN]: "Admin Tools",
  [CATEGORY.FAVOURITES]: "Favourites",
};

// Items presented under "Pages". Anything not listed here that arrives through
// the campus-portal / other-tools collections is shown under "Campus Portals",
// so an unclassified item can never disappear (or appear) because of this map.
export const PAGE_ITEM_IDS = new Set([
  "student-calendar",
  "institute-calendar",
  "student-societies",
  "lost-and-found",
  "public-forms",
]);

export const categoryForSource = (source, item) => {
  if (source === "dashboards") return CATEGORY.DASHBOARDS;
  if (source === "adminTools") return CATEGORY.ADMIN;
  return PAGE_ITEM_IDS.has(item.id) ? CATEGORY.PAGES : CATEGORY.PORTALS;
};

// Client-side search over items that are already authorized. Every
// whitespace-separated token must appear in the title or description.
export const searchItems = (items, query) => {
  const tokens = String(query || "").toLowerCase().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return items;
  return items.filter((item) => {
    const haystack = `${item.title} ${item.description || ""}`.toLowerCase();
    return tokens.every((token) => haystack.includes(token));
  });
};
